import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { Separator } from "../../../components/Common/CommonStyles";

const ActionButtons = ({
  onAgregarCobertura,
  onEnviarCoberturas,
  isLoading,
  disabled,
  enviandoCoberturas,
}) => {
  return (
    <Section width="100%" display="flex" justify="flex-end">
      <CustomButton
        label="Agregar cobertura"
        onClick={onAgregarCobertura}
        height="40px"
        width="200px"
        isLoading={enviandoCoberturas || isLoading}
        disabled={isLoading || enviandoCoberturas}
      />
      <Separator width="10px" />
      <CustomButton
        label="Enviar coberturas"
        onClick={onEnviarCoberturas}
        isLoading={enviandoCoberturas || isLoading}
        disabled={isLoading || disabled || enviandoCoberturas}
        height="40px"
        width="200px"
      />
    </Section>
  );
};

export default ActionButtons;

